var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15425_5751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 20C17 20 18 20 18 19C18 18 17 15 12 15C7 15 6 18 6 19C6 20 7 20 7 20H17ZM7.005 19.056V19.054V19.056ZM7.022 19H16.978C16.9827 18.9995 16.9874 18.9988 16.992 18.998L17 18.996C16.999 18.75 16.846 18.01 16.168 17.332C15.516 16.68 14.289 16 12 16C9.71 16 8.484 16.68 7.832 17.332C7.154 18.01 7.002 18.75 7 18.996C7.00732 18.9974 7.01465 18.9987 7.022 19ZM16.996 19.056V19.054V19.056ZM12 13C12.5304 13 13.0391 12.7893 13.4142 12.4142C13.7893 12.0391 14 11.5304 14 11C14 10.4696 13.7893 9.96086 13.4142 9.58579C13.0391 9.21071 12.5304 9 12 9C11.4696 9 10.9609 9.21071 10.5858 9.58579C10.2107 9.96086 10 10.4696 10 11C10 11.5304 10.2107 12.0391 10.5858 12.4142C10.9609 12.7893 11.4696 13 12 13ZM15 11C15 11.7956 14.6839 12.5587 14.1213 13.1213C13.5587 13.6839 12.7956 14 12 14C11.2044 14 10.4413 13.6839 9.87868 13.1213C9.31607 12.5587 9 11.7956 9 11C9 10.2044 9.31607 9.44129 9.87868 8.87868C10.4413 8.31607 11.2044 8 12 8C12.7956 8 13.5587 8.31607 14.1213 8.87868C14.6839 9.44129 15 10.2044 15 11ZM21.854 11.146C21.9006 11.1924 21.9375 11.2476 21.9627 11.3084C21.9879 11.3691 22.0009 11.4342 22.0009 11.5C22.0009 11.5658 21.9879 11.6309 21.9627 11.6916C21.9375 11.7524 21.9006 11.8076 21.854 11.854L18.854 14.854C18.8076 14.9006 18.7524 14.9375 18.6916 14.9627C18.6309 14.9879 18.5658 15.0009 18.5 15.0009C18.4342 15.0009 18.3691 14.9879 18.3084 14.9627C18.2476 14.9375 18.1924 14.9006 18.146 14.854L16.646 13.354C16.5521 13.2601 16.4994 13.1328 16.4994 13C16.4994 12.8672 16.5521 12.7399 16.646 12.646C16.7399 12.5521 16.8672 12.4994 17 12.4994C17.1328 12.4994 17.2601 12.5521 17.354 12.646L18.5 13.793L21.146 11.146C21.1924 11.0994 21.2476 11.0625 21.3084 11.0373C21.3691 11.0121 21.4342 10.9991 21.5 10.9991C21.5658 10.9991 21.6309 11.0121 21.6916 11.0373C21.7524 11.0625 21.8076 11.0994 21.854 11.146Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15425_5751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckman);
export default __webpack_public_path__ + "static/media/iconCheckman.8955a3e56de115b24735bc3c9aa11407.svg";
export { ForwardRef as ReactComponent };